<template>
  <Card 
    :title="$t('SessionViewer.RFM')"
    id="RFM"
  >
    <CardSection class="rfmTables" v-if="rfm">
      <Layout>
        <LayoutSection>
          <table class="table table-bordered table-condensed">
            <thead>
              <tr>
                <th colspan="2">
                  {{$t('SessionViewer.Recency')}}
                  <span class="rfmHeaderScore">{{rfmHeaderScores.r}}</span>
                </th>
              </tr>
              <tr>
                <th>{{$t('SessionViewer.Score')}}</th>
                <th>{{$t('SessionViewer.Purchased in the last')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in recency"
                :key="index"
                :class="{'rfm--active': row.active}"
              >
                <td>{{row.score}}</td>
                <td>
                  {{row.before}} — {{row.after}} {{$t('SessionViewer.days')}} <template v-if="row.active">({{row.activeValue}} {{$t('SessionViewer.days')}})</template>
                </td>
              </tr>
            </tbody>
          </table>
        </LayoutSection>
        <LayoutSection>
          <table class="table table-bordered table-condensed">
            <thead>
              <tr>
                <th colspan="2">
                  {{$t('SessionViewer.Frequency')}}
                  <span class="rfmHeaderScore">{{rfmHeaderScores.f}}</span>
                </th>
              </tr>
              <tr>
                <th>{{$t('SessionViewer.Score')}}</th>
                <th>{{$t('SessionViewer.Purchases in the period')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in frequency"
                :key="index"
                :class="{'rfm--active': rfm.frequency.score === row.score}"
              >
                <td>{{row.score}}</td>
                <td>{{row.before}} — {{row.after}} <template v-if="row.active">({{row.activeValue}})</template></td>
              </tr>
            </tbody>
          </table>
        </LayoutSection>
        <LayoutSection>
          <table class="table table-bordered table-condensed">
            <thead>
              <tr>
                <th colspan="2">
                  {{$t('SessionViewer.Monetary')}}
                  <span class="rfmHeaderScore">{{rfmHeaderScores.m}}</span>
                </th>
              </tr>
              <tr>
                <th>{{$t('SessionViewer.Score')}}</th>
                <th>{{$t('SessionViewer.Total Spend')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in monetary"
                :key="index"
                :class="{'rfm--active': rfm.monetary.score === row.score}"
              >
                <td>{{row.score}}</td>
                <td>
                  <Formatter type="currency" :currency="currency" :value="row.before"/> 
                    {{ row.after ? '—' : '+' }} 
                  <Formatter v-if="row.after" type="currency" :currency="currency" :value="row.after"/> 
                  <template v-if="row.active"> (<Formatter type="currency" :currency="currency" :value="row.activeValue"/>)</template>
                </td>
              </tr>
            </tbody>
          </table>
        </LayoutSection>
      </Layout>
    </CardSection>
    <CardSection v-else>
      <List tight :emptyText="$t('SessionViewer.noRFMData')"/>
    </CardSection>
  </Card>
</template>

<script>
// import SessionFlow from '../classes/SessionFlow.class'

export default {
  name: 'SessionViewerRFM',
  props: {
    session: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sessionFlow: null,
      rfm: null
    }
  },
  mounted() {
    // this.sessionFlow = SessionFlow.get()
    this.rfm = this.session.userSite.rfm || null
  },
  computed: {
    rfmHeaderScores() {
      const r = this.rfm.recency.score
      const f = this.rfm.frequency.score
      const m = this.rfm.monetary.score
      return {
        r: r > 0 ? `${this.$t('SessionViewer.Score')}: ${r}` : `${this.$t('SessionViewer.Score')}: N/A`,
        f: f > 0 ? `${this.$t('SessionViewer.Score')}: ${f}` : `${this.$t('SessionViewer.Score')}: N/A`,
        m: m > 0 ? `${this.$t('SessionViewer.Score')}: ${m}` : `${this.$t('SessionViewer.Score')}: N/A`
      }
    },
    recency() {
      const data = this.rfm.recency
      return data.buckets.map((val, index, rows) => {
        const next = index < 4 ? rows[index + 1] + 1 : 0
        const row = {
          score: index + 1,
          before: val,
          after: next
        }
        if (row.score === data.score) {
          row.activeValue = data.value
          row.active = true
        }
        return row
      })
    },
    frequency() {
      const data = this.rfm.frequency
      return data.buckets.map((val, index, rows) => {
        const before = index > 0 ? (rows[index - 1] + 1) : val
        const row = {
          score: index + 1,
          before,
          after: val
        }
        if (row.score === data.score) {
          row.activeValue = data.value
          row.active = true
        }
        return row
      })
    },
    monetary() {
      const data = this.rfm.monetary
      return data.buckets.map((val, index, rows) => {
        const before = index > 0 ? rows[index - 1] : 0.01
        let after = null
        if (index < 4) {
          after = (val - 0.01)
        }
        const row = {
          score: index + 1,
          before,
          after
        }
        if (row.score === data.score) {
          row.activeValue = data.value
          row.active = true
        }
        return row
      })
    }
  },
  filters: {

  }
}
</script>

<style lang="scss">
#RFM {
  .rfm--active {
    background-color: #EEEEEE;
  }
}
</style>